import { combineEpics } from 'redux-observable';

import { applicationResultEpic } from './applicationResult.epic';
import { authorizedEpic, phoneInUseEpic, authorizeConflictEpic, authorizedVerifyEpic } from './authorized.epic';
import { savePreviewCardEpic } from './previewCard.epic';
import { requestVerificationEpic } from './requestVerification.epic';
import { saveBusinessInfoOneEpic } from './saveBusinessInfoOneEpic';
import { saveBusinessInfoTwoEpic } from './saveBusinessInfoTwoEpic';
import { saveBusinessInfoVerifyEpic } from './saveBusinessInfoVerifyEpic';
import { savePersonalInfoSmallBusinessEpic, savePersonalInfoLargeBusinessEpic } from './savePersonalInfo.epic';
import { saveSpendIntentEpic } from './saveSpendIntentEpic';

export const navigationEpics = combineEpics(
  requestVerificationEpic,
  saveBusinessInfoOneEpic,
  saveBusinessInfoTwoEpic,
  saveBusinessInfoVerifyEpic,
  saveSpendIntentEpic,
  savePersonalInfoSmallBusinessEpic,
  savePersonalInfoLargeBusinessEpic,
  authorizedEpic,
  authorizeConflictEpic,
  phoneInUseEpic,
  authorizedVerifyEpic,
  savePreviewCardEpic,
  applicationResultEpic,
);
